import {GetterTree, MutationTree, Module, ActionTree} from 'vuex'
import {RootState, UiState} from '../types'

type UiGetter = GetterTree<UiState, RootState>

const state: UiState = {
  isLoading: false,
  isEdit: false,
  entryPoint: null
}

export const getters: UiGetter = {
  isLoadingGetter: (state) => state.isLoading,
  isEditGetter: (state) => state.isEdit
}

export const actions: ActionTree<UiState, RootState> = {
  setIsEditAction({commit}) {
    commit('setIsEditMutation')
  },
  resetIsEditAction({commit}) {
    commit('resetIsEditMutation')
  }
}

const mutations: MutationTree<UiState> = {
  startLoadingMutation(state) {
    state.isLoading = true
  },
  stopLoadingMutation(state) {
    state.isLoading = false
  },
  setIsEditMutation(state) {
    state.isEdit = true
  },
  resetIsEditMutation(state) {
    state.isEdit = false
  }
}

export const ui: Module<UiState, RootState> = {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
}
